import Book from '@/components/Book';
import Footer from '@/components/footer/FooterWrapper';
import Layout from '@/components/layout/LayoutWrapper';

const BookPage = () => {
	const BOOK_URL =
		'https://www.amazon.com/Calm-Michael-Acton-Smith/dp/0062439170/ref=sr_1_1?ie=UTF8&qid=1511804431&sr=8-1';

	return (
		<Layout pageName="book" title="Calm - The Calm Book">
			<Book bookBuyURL={BOOK_URL} />
			<Footer initialTheme="light" />
		</Layout>
	);
};

export default BookPage;
